module.exports = __webpack_public_path__ + "img/logo-myhappily-latest@2x.4caae96d.png";